import { render, staticRenderFns } from "./DashboardFilterBar.vue?vue&type=template&id=651647e2&scoped=true"
import script from "./DashboardFilterBar.vue?vue&type=script&lang=js"
export * from "./DashboardFilterBar.vue?vue&type=script&lang=js"
import style0 from "./DashboardFilterBar.vue?vue&type=style&index=0&id=651647e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651647e2",
  null
  
)

export default component.exports